import React, { useState } from "react";
import "./Carousel.css";

const Carousel = ({ items }) => {
	const [currentSlide, setCurrentSlide] = useState(0);

	// Handlers to navigate the carousel
	const goToPrevious = () => {
		setCurrentSlide(currentSlide === 0 ? items.length - 1 : currentSlide - 1);
	};

	const goToNext = () => {
		setCurrentSlide(currentSlide === items.length - 1 ? 0 : currentSlide + 1);
	};

	return (
		<div className="carousel">
			<img
				src={items[currentSlide].image}
				alt="Carousel Slide"
				className="carousel-image"
			/>
			<div className="carousel-text">
				<h3>{items[currentSlide].title}</h3>
				<p>{items[currentSlide].description}</p>
			</div>
			<div className="carousel-controls">
				<button onClick={goToPrevious}>&lt;</button>
				<button onClick={goToNext}>&gt;</button>
			</div>
		</div>
	);
};

export default Carousel;
